// Shared UI primitives for pages
export const inputCls =
  "w-full bg-transparent border border-white/20 px-3 py-2 text-sm text-white placeholder:text-[#737373] focus:outline-none focus:border-[#007AFF] focus:ring-1 focus:ring-[#007AFF] transition-colors";

export function PageHeader({ eyebrow, title, accent, children }) {
  return (
    <div className="flex items-end justify-between mb-8 pb-6 border-b border-white/10 flex-wrap gap-4">
      <div>
        <div className="font-mono-tab text-[10px] tracking-[0.2em] uppercase text-[#737373] mb-2">
          {eyebrow}
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter uppercase">
          {title} {accent && <span className="text-[#007AFF]">{accent}</span>}
        </h1>
      </div>
      {children}
    </div>
  );
}

export function Field({ label, children, span }) {
  return (
    <label className={`block ${span || ""}`}>
      <div className="font-mono-tab text-[10px] tracking-[0.2em] uppercase text-[#737373] mb-1.5">
        {label}
      </div>
      {children}
    </label>
  );
}

export function SectionCard({ title, eyebrow, children, action }) {
  return (
    <div className="border border-white/10 bg-[#121212]">
      <div className="px-6 py-4 border-b border-white/10 flex items-center justify-between gap-4">
        <div>
          {eyebrow && (
            <div className="font-mono-tab text-[10px] tracking-[0.2em] uppercase text-[#737373]">
              {eyebrow}
            </div>
          )}
          <h2 className="font-display text-xl font-bold tracking-tight mt-1">{title}</h2>
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}
